import { ArrowBackIosNew } from '@mui/icons-material'
import { LoadingButton } from '@mui/lab'
import { useTranslation } from 'react-i18next'
import { MODULE_NAME } from '../../strings'

interface GoBackButtonProps {
  onClick: () => void
  disabled?: boolean
  loading?: boolean
}

const GoBackButton = ({ onClick, disabled, loading }: GoBackButtonProps) => {
  const { t } = useTranslation(MODULE_NAME)

  return (
    <LoadingButton
      variant="text"
      color="primary"
      sx={{ textTransform: 'none' }}
      startIcon={<ArrowBackIosNew />}
      onClick={onClick}
      disabled={disabled}
      loading={loading}
    >
      {t('login.goBack')}
    </LoadingButton>
  )
}

export default GoBackButton
